// extracted by mini-css-extract-plugin
module.exports = {"workCard":"Works_workCard__S-pha","teachTitle":"Works_teachTitle__1Z4Dz"};